// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

export const environment = {
  production: false,
  apiUrl: 'https://api.stage.realtybrix.com',
  apiPrefix: '/v1',
  googleMapsApiKey: 'AIzaSyDE8wO1HtbgROb7MAv0COqfUguOuol3HL0',
};
